import React, { HTMLAttributes, useEffect, useState } from 'react';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils';
import './Tooltip.scss';
const rootClassName = 'component-tooltip';

export interface TooltipProps extends HTMLAttributes<HTMLDivElement> {
  id?: string;
  className?: string;
  position?: TooltipPosition;
  children?: any;
}
export default function Tooltip(props: TooltipProps) {
  const [id] = useState(props.id || getUniqueKey());
  const getProps = () => {
    return {
      ...props,
      id,
      className: getMergedClassNames([
        rootClassName,
        props.className,
        `${rootClassName}-${props.position}`
      ])
    };
  };

  useEffect(() => {
    // DidMount
    const element = document.querySelector(`#${id}`) as HTMLElement;
    const triangle = element.querySelector(
      `.${rootClassName}-triangle`
    ) as HTMLElement;

    const bounding = element.getBoundingClientRect();
    const ScreenWidth = window.innerWidth;
    if (
      props.position === TooltipPosition.Top ||
      props.position === TooltipPosition.Bottom
    ) {
      const overflowRight = ScreenWidth - bounding.right;
      const overflowLeft = bounding.left;
      if (overflowRight < 0) {
        const soma =
          parseInt(element.style.left) -
          Math.abs(parseInt(String(overflowRight))) -
          15;
        element.style.left = `${soma}px`;
        triangle.style.transform = `translateX(${
          3.5 + Math.abs(parseInt(String(overflowRight))) + 10
        }px)`;
      } else if (overflowLeft < 0) {
        const soma = 15 + parseInt(String(bounding.width / 2));
        element.style.left = `${soma}px`;
        triangle.style.transform = `translateX(${-1.5 + -soma / 2}px)`;
      }
    }
  }, [id, props.position]);

  return (
    <div className={`${rootClassName}-outer`}>
      <div {...getProps()}>
        {props.children}
        <div className={`${rootClassName}-triangle`} />
      </div>
    </div>
  );
}

Tooltip.defaultProps = {
  position: TooltipPosition.Top
};
